import { SAVE_USER } from '../constants/actionTypes'

export const initUser = user => ({
  type: SAVE_USER,
  value: {
    logged_in: true,
    ...user,
  },
})
